var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"items":_vm.form,"fields":_vm.campos,"empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"head-variant":"light","stacked":"md","show-empty":"","responsive":"","striped":"","hover":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }